// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n.btn.sharp {\r\n    border-radius:0;\r\n  }\r\n\r\n  ", "",{"version":3,"sources":["webpack://src/styles.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;IACI,eAAe;EACjB","sourcesContent":["/* You can add global styles to this file, and also import other style files */\r\n.btn.sharp {\r\n    border-radius:0;\r\n  }\r\n\r\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
